import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { reportErrorToConsole, useNeedHelp } from '@applyonline/shared';
import { ExpandableSection, InputText, ScrollableAlert } from '@applyonline/shared/components';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
const NeedHelp = ({ creditApplicationId, description, financingProgram, phoneNumber, phoneNumberLink }) => {
    const { t } = useTranslation('shared');
    const [needHelp, pending, isSuccess, isError] = useNeedHelp(financingProgram);
    const [comment, setComment] = useState('');
    const handleSubmit = () => {
        needHelp({
            creditApplicationId,
            description,
            comment: comment || null,
        }).catch(reportErrorToConsole);
        setComment('');
    };
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            event.target.blur();
            handleSubmit();
        }
    };
    const handleOnChange = (e) => {
        setComment(e.target.value);
    };
    return (_jsx("div", { style: { marginTop: '16px', marginBottom: '32px' }, children: _jsx(ExpandableSection, { toggleText: t('help.toggle'), children: _jsxs("div", { children: [_jsx("div", { style: { marginTop: '8px' }, children: _jsx(Trans, { i18nKey: "help.description", ns: "shared", values: {
                                phoneNumber,
                            }, components: { a: _jsx(Link, { to: phoneNumberLink, style: { textWrap: 'nowrap' } }) } }) }), _jsx(ScrollableAlert, { showAlert: isSuccess || isError, type: isSuccess ? 'success' : 'error', message: isSuccess ? t('help.success') : t('common.unexpectedError'), style: { marginBottom: 0, marginTop: '16px' } }), !isSuccess && (_jsxs("div", { style: { display: 'flex', gap: '16px', alignItems: 'end' }, children: [_jsx(InputText, { id: "help-input", style: { flexGrow: 1 }, placeholder: t('help.label'), onKeyDown: handleKeyDown, value: comment, onChange: handleOnChange, disabled: pending, max: 4000 }), _jsx("div", { className: "control-group-end", children: _jsx("button", { type: "button", className: "btn btn-blue", style: { marginTop: 0, width: '100%' }, onClick: handleSubmit, disabled: pending, children: t('help.submit') }) })] }))] }) }) }));
};
export default NeedHelp;
